import {isNotNil} from 'ramda';

import {SourcingVehicleDetailResponseBody} from '@dms/api/core';

export interface MinMaxValues {
  minPrice: number;
  maxPrice: number;
  minMileage: number;
  maxMileage: number;
  minYear: number;
  maxYear: number;
}

export const getMinMaxValues = (vehicles: SourcingVehicleDetailResponseBody[]): MinMaxValues => {
  const minPrice = vehicles.reduce((acc, vehicle) => {
    const price = vehicle.sourcingVehicle.price?.withVat;
    return isNotNil(price) && price < acc ? price : acc;
  }, Infinity);

  const maxPrice = vehicles.reduce((acc, vehicle) => {
    const price = vehicle.sourcingVehicle.price?.withVat;
    return isNotNil(price) && price > acc ? price : acc;
  }, 0);

  const minMileage = vehicles.reduce((acc, vehicle) => {
    const mileage = vehicle.sourcingVehicle.mileage;
    return isNotNil(mileage) && mileage < acc ? mileage : acc;
  }, Infinity);

  const maxMileage = vehicles.reduce((acc, vehicle) => {
    const mileage = vehicle.sourcingVehicle.mileage;
    return isNotNil(mileage) && mileage > acc ? mileage : acc;
  }, 0);

  const minYear = vehicles.reduce((acc, vehicle) => {
    const year = vehicle.sourcingVehicle.year;
    return isNotNil(year) && year < acc ? year : acc;
  }, Infinity);

  const maxYear = vehicles.reduce((acc, vehicle) => {
    const year = vehicle.sourcingVehicle.year;
    return isNotNil(year) && year > acc ? year : acc;
  }, 0);

  return {
    minPrice: minPrice === Infinity ? 0 : minPrice,
    maxPrice,
    minMileage: minMileage === Infinity ? 0 : minMileage,
    maxMileage,
    minYear: minYear === Infinity ? 0 : minYear,
    maxYear,
  };
};
